var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_70639_5315)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.909058,
    width: 10,
    height: 10,
    rx: 2.27273,
    fill: "#3E3E3E",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70639_5315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35597 6.60707L7.6609 5.19041C7.81431 5.12412 7.81431 4.90821 7.6609 4.84192L4.35597 3.42526C4.23097 3.37033 4.09271 3.46313 4.09271 3.5976L4.09082 4.47071C4.09082 4.56541 4.1609 4.64685 4.25559 4.65821L6.93173 5.01616L4.25559 5.37223C4.1609 5.38548 4.09082 5.46692 4.09082 5.56162L4.09271 6.43472C4.09271 6.56919 4.23097 6.662 4.35597 6.60707V6.60707Z",
    fill: "#E5E5E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_70639_5315",
    x: -0.000033319,
    y: 0,
    width: 11.8182,
    height: 11.8182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.909091
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.454545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_70639_5315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_70639_5315",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70639_5315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.54545,
    height: 4.54545,
    fill: "white",
    transform: "translate(3.63635 2.72705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.eccc3cec80639a1e11af6ac65e176351.svg";
export { ForwardRef as ReactComponent };